import { render, staticRenderFns } from "./RMA.vue?vue&type=template&id=234124fc&scoped=true"
import script from "./RMA.vue?vue&type=script&lang=js"
export * from "./RMA.vue?vue&type=script&lang=js"
import style0 from "./RMA.vue?vue&type=style&index=0&id=234124fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234124fc",
  null
  
)

export default component.exports